export default "__VITE_ASSET__207537b5__"